module.exports = __webpack_public_path__ + "img/logo.be8fd40e.svg";